import React from "react";
import { Link } from "react-router-dom";
import {  HostAiEarth1,
    HostAiEarth2,
    HostAiEarth3} from './data'
const AiEarth = () => {
  return (
    <div className="menu-right-content">
      <ul className="tabpanel-column1">
        {HostAiEarth1.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
      <ul className="tabpanel-column2">
        {HostAiEarth2.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
      <ul className="tabpanel-column3">
        {HostAiEarth3.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default AiEarth;
